import React from 'react';
import {
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Divider,
    Grid,
    Tab,
    Tabs,
} from '@mui/material';
import Overview from "./Overview";
import LatestBlocksContent from './LatestBlocks';
import LatestTransactionsContent from './LatestTransactions';
import LatestMempoolTransactionsContent from './LatestMempoolTransactions';


const Dashboard = () => {
    const [value, setValue] = React.useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };
    return (
        <Grid container spacing={4} sx={{py: 1}}>
            <Grid item sm={12} md={12} sx={{width: 1, height: '100%'}}>
                <Overview/>
            </Grid>
            <Grid item sm={12} md={12} sx={{width: 1, height: '100%'}}>
                <Card>
                    <CardHeader
                        title={
                            <Tabs
                                variant="fullWidth"
                                value={value}
                                onChange={handleChange}
                            >
                                <Tab label="Latest Blocks" />
                                <Tab label="Latest Transactions" />
                                <Tab label="Mempool" />
                            </Tabs>
                        }
                    />
                    <Divider/>
                    <CardContent>
                        {value === 0 && <Box> <LatestBlocksContent/> </Box>}
                        {value === 1 && <Box> <LatestTransactionsContent/> </Box>}
                        {value === 2 && <Box> <LatestMempoolTransactionsContent/> </Box>}
                    </CardContent>
                    <CardActions sx={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                        <Button variant="contained" href={value === 0 ? "/blocks" : "/txs"} size="small"
                                sx={{width: '100%', height: 24, textTransform: 'none'}}>
                            VIEW ALL
                        </Button>
                    </CardActions>
                </Card>
            </Grid>
        </Grid>
    );
};

export default Dashboard;
